import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { CardWrapper } from './components';
import { getCardStepLayoutStyles } from './styles/card-step-layout-styles';

export function CardStepLayout(props) {
  const {
    children,
    className,

    onRenderPageBanner,
    onRenderPageHeader,
    onRenderPageFooter,

    cardBasicProps,
    previousButtonLabel,
    nextButtonLabel,
    onPreviousClick,
    onNextClick,
    onCancelClick,
    isNextButtonDisabled,
    disableButtons,
  } = props;
  const classes = useDefaultStyles(getCardStepLayoutStyles);

  return (
    <div className={classNames('step-layout-container', className, classes.stepLayoutContainer)}>
      {_.isFunction(onRenderPageBanner) && onRenderPageBanner()}
      <div className={classNames('step-layout-content-container', classes.stepLayoutContentContainer)}>
        <div className={classNames('step-layout-header', classes.stepLayoutHeaderContainer)}>
          {_.isFunction(onRenderPageHeader) && onRenderPageHeader()}
        </div>
        <div className={classNames('step-content-with-footer', classes.stepContentContainer)}>
          <CardWrapper
            {...cardBasicProps}
            previousButtonLabel={previousButtonLabel}
            nextButtonLabel={nextButtonLabel}
            onPreviousClick={onPreviousClick}
            onNextClick={onNextClick}
            onCancelClick={onCancelClick}
            isNextButtonDisabled={isNextButtonDisabled}
            disableButtons={disableButtons}
          >
            {children}
          </CardWrapper>
          <div className={classNames('step-layout-footer', classes.stepLayoutFooterContainer)}>
            {_.isFunction(onRenderPageFooter) && onRenderPageFooter()}
          </div>
        </div>
      </div>
    </div>
  );
}

CardStepLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  className: PropTypes.string,

  onRenderPageBanner: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onRenderPageHeader: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onRenderPageFooter: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

  cardBasicProps: PropTypes.shape({
    className: PropTypes.string,
    title: PropTypes.string,
    titleHelpTopic: PropTypes.string,
  }),
  previousButtonLabel: PropTypes.string,
  nextButtonLabel: PropTypes.string,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  isNextButtonDisabled: PropTypes.bool,
  disableButtons: PropTypes.bool,
};

CardStepLayout.defaultProps = {
  children: null,
  className: null,

  onRenderPageBanner: null,
  onRenderPageHeader: null,
  onRenderPageFooter: null,

  cardBasicProps: null,
  previousButtonLabel: null,
  nextButtonLabel: null,
  onPreviousClick: null,
  onNextClick: null,
  onCancelClick: null,
  isNextButtonDisabled: false,
  disableButtons: false,
};
